module.exports = __webpack_public_path__ + "static/media/login.05298ff7.png";